var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./breadcrumb-nav.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5e6d4a37\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./breadcrumb-nav.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/breadcrumb-nav/breadcrumb-nav.vue
// module id = 463
// module chunks = 99